import React from 'react';
import { Layout } from 'antd';
import Header from '../../containers/Header';
import ActionPanel from '../../containers/ActionPanel';

const { Content: AntdContent, Header: AntdHeader } = Layout;

export function PageLayout({
  children,
  apiClient,
  trackMethod,
  eventBus,
}: {
  children: JSX.Element;
  apiClient: unknown;
  trackMethod: (
    eventName: string,
    eventPayload?: string | number | object,
  ) => void;
  eventBus: unknown;
}) {
  return (
    <Layout className="as-PageLayout">
      <AntdHeader className="as-PageHeader">
        <ActionPanel />
        <Header
          {
            // Note: We are using the spread operator to bypass
            // the props ts error, this will be fixed in the next step
            // we are going to use the correct types in new Header component
            ...({
              apiClient,
              eventBus,
              trackMethod,
            } as any)
          }
        />
      </AntdHeader>
      <AntdContent className="as-PageContent">{children}</AntdContent>
    </Layout>
  );
}
